import { ReactNode } from 'react';

export enum LeftNavMenuType {
  Leaf = 'leaf',
  WithChildren = 'with_children',
}

export type LeftNavMenus = (LeftNavMenuItem | LeftNavMenuWithChildren)[];
export type LeftNavMenuItem = {
  type: LeftNavMenuType.Leaf;
  path: string;
  key: string;
  icon: ReactNode;
  featureEnabled?: boolean;
  hasPermission?: boolean;
};

export type LeftNavMenuWithChildren = {
  type: LeftNavMenuType.WithChildren;
  key: string;
  icon: ReactNode;
  children: LeftNavMenuItem[];
};
